import VisitedGrid from "../../components/organismos/specials/VisitedGrid";
import useVisitedMonitoring from "../../hooks/monitoring/useVisitedMonitorings";
import { Box } from "@mui/material";

/**
 * Pagina que muestra el historial de acceso de los visitantes.
 *
 * Utiliza el hook `useVisitedMonitoring` para obtener el historial de
 * acceso de los visitantes.
 *
 * El componente `VisitedGrid` se encarga de mostrar el historial de
 * acceso en una tabla.
 *
 * @returns {JSX.Element}
 */
const VisitedMonitored = () => {
  const { ...props } = useVisitedMonitoring();

return (
  <Box>

        <VisitedGrid {...props} />
  </Box>
);

};

export default VisitedMonitored;
